import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeOperationIcon,
  NodeSize,
  NodeType,
  NodeTypeCategory
} from "../Base";
import { DataType, primitiveTypes } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { emptyObjectSchemaId, listOfEmptyObjectSchemaId } from "../DataSchemas";

const listInputName = "list";
const itemInputName = "item";
const listOutputName = "result";

const dataTypePropertyName = "dataType";
const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.listAdd,
  category: NodeTypeCategory.lists,
  featureToggle: "feat-core-2471-flows-list-add-empty-nodes",
  operationIcon: NodeOperationIcon.add,
  controlOutputs: [],
  dataInputs: [
    {
      enabled: true,
      type: DataType.OBJECTLIST,
      name: listInputName,
      required: true,
      schemaId: listOfEmptyObjectSchemaId
    },
    { enabled: true, type: DataType.OBJECT, name: itemInputName, required: true, schemaId: emptyObjectSchemaId }
  ],
  dataOutputs: [
    { enabled: true, type: DataType.OBJECTLIST, name: listOutputName, schemaId: listOfEmptyObjectSchemaId }
  ],
  listToItem: true,
  nodeConfigProperties: [
    {
      name: dataTypePropertyName,
      label: "Type",
      propertyType: NodeConfigPropertyType.DataType,
      clearPropertiesOnChange: [schemaProperty],
      options: {
        dataTypes: [DataType.OBJECT, DataType.OBJECTREFERENCE].concat(primitiveTypes),
        dataProperties: [listInputName, itemInputName, listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: dataTypePropertyName, propertyValues: [DataType.OBJECT, undefined] },
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        displayProperty: schemaNameProperty,
        dataProperties: [listInputName, itemInputName, listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaProperty,
      label: "Reference",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: { propertyName: dataTypePropertyName, propertyValues: [DataType.OBJECTREFERENCE] },
      options: {
        changeSchemaOnConnection: true,
        referenceOnly: true,
        displayProperty: schemaNameProperty,
        dataProperties: [listInputName, itemInputName, listOutputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    }
  ],
  size: NodeSize.Small,
  evaluate: () => {
    return {
      output: {},
      activeControlHandleIds: []
    };
  }
});

export const ListAddNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
